module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "breadcrumb is-small",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'playlists'
      }
    }
  }, [_vm._v("\n              Playlists\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.playlist ? _vm.playlist.name : "") + "\n            ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [(_vm.playlist) ? _c('div', {
    staticClass: "container"
  }, [(_vm.editMode) ? _c('playlist-edit', {
    attrs: {
      "initial-playlist": _vm.playlist,
      "initial-playlist-items": _vm.playlistItems
    },
    on: {
      "update": function($event) {
        return _vm.updatePlaylistElement($event)
      }
    }
  }) : _c('playlist-show'), _vm._v(" "), (_vm.editMode) ? _c('a', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.deleteThisPlaylist()
      }
    }
  }, [_c('span', [_vm._v("Delete")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "add button is-large is-warning",
    on: {
      "click": function($event) {
        return _vm.toggleEdit()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-medium"
  }, [(_vm.editMode) ? _c('i', {
    staticClass: "fas fa-check"
  }) : _c('i', {
    staticClass: "fas fa-pencil-alt"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc29f88c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Playlist.vue
// module id = 328
// module chunks = 2